import { FilterConfig } from "@/interfaces/filter.interface";
import { FilterOperator } from "./filter.constant";
import { CorpusType, CorpusStatus } from "./corpus.constants";

/**
 * Corpus-specific filter configuration
 */
export const CORPUS_FILTER_CONFIG: FilterConfig = {
  fields: [
    {
      id: "corpusName",
      label: "Corpus Name",
      type: "select",
      operators: [FilterOperator.EQUALS, FilterOperator.NOT_EQUALS],
      options: [
        CorpusType.POLICY,
      ],
      backendKey: "corpusType",
      placeholder: "Select Corpus Name",
    },
    {
      id: "ingestionStatus",
      label: "Ingestion Status",
      type: "select",
      operators: [FilterOperator.EQUALS, FilterOperator.NOT_EQUALS],
      options: [
        CorpusStatus.SUCCESS,
        CorpusStatus.FAILED,
        CorpusStatus.IN_PROGRESS,
      ],
      backendKey: "status",
      placeholder: "Select Ingestion Status",
    },
  ],
  maxFilters: 2,
  allowDuplicateFields: false,
};

